import React, { useState, FormEvent } from 'react';
import './Register.scss';
import { BaseReact } from '../../base.model';
import { Link } from 'react-router-dom';

import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import { AmazonProfile } from '../../models/Profile';
import sharedToasterSubject from '../../services/shared.toasterSubject';

import { LogoBanner } from '../visuals/banner.logo';
import InputAnimated from './input/input';

interface RegisterAccountResponse {
    amazonProfile: AmazonProfile;
    spConsentUrl: string;
}

interface RegisterProps extends BaseReact { }

function Register({ history, location }: RegisterProps) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')
    // Account data
    const [companyName, setCompanyName] = useState('');
    const [registering, setRegistering] = useState(false);

    const [registerAccount] = useMutation(graphqlSchema.PROFILE.SETUP.registerAccount, {
        onCompleted: ({ registerAccount }: { registerAccount: RegisterAccountResponse }) => {
            console.log('Registration: ', registerAccount);
            // >> Redirect to auth confirmation for AWS, the session is only created after Amazon consent
            if (!registerAccount.spConsentUrl) {
                setRegistering(false);
                sharedToasterSubject.next({ type: 'error', message: 'No se pudo iniciar la conexión con Amazon, inicia sesión para continuar' })
                return;
            }
            window.location.replace(registerAccount.spConsentUrl)
        },
        onError: (e) => {
            console.error('Error Registration: ', e.graphQLErrors[0].message);
            setRegistering(false);
            sharedToasterSubject.next({ type: 'error', message: `${e.graphQLErrors[0].message}, confirma que tu ID de vendedor y Token de acceso son correctos` })
        }
    })

    const testForEmail = (str: string) => {
        // eslint-disable-next-line no-useless-escape
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str)
    }

    const inputsValid = () => {
        if (passwordConfirm !== password || !password || !passwordConfirm) {
            return false;
        }
        if (!companyName || !email) {
            return false;
        }
        const emailValid = testForEmail(email)
        if (!emailValid) {
            return false;
        }
        return true
    }

    const submitRegistration = (e: FormEvent) => {
        e.preventDefault();
        if (!inputsValid()) {
            return;
        }
        setRegistering(true);
        console.log('<submitRegistration> Calling registration: ', {
            email,
            companyName,
        });
        registerAccount({
            variables: {
                account: {
                    email,
                    password,
                    companyName,
                }
            }
        })
    }

    const _setEmail = (e: string) => {
        setEmail(e.toLowerCase().trim());
    }

    return (
        <div id="Register">
            <div className="_loginContainer">
                <LogoBanner />

                <div className="_logoSelect">
                    <div className="_withReturn">
                        <a href="https://fiscalpop.com/login?type=ecommerce">
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M26 13.5H1" stroke="#AFAFAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 26L1 13.5L13.5 1" stroke="#AFAFAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <div> <h2 className="gray">eCommerce </h2><h3>Amazon </h3></div>
                    </div>
                    <form onSubmit={submitRegistration}>
                        <InputAnimated
                            type="text"
                            value={email}
                            label="Email"
                            hasError={!!email && !testForEmail(email)}
                            onChange={_setEmail}
                        />
                        <InputAnimated
                            type="text"
                            value={companyName}
                            label="Nombre de tu empresa"
                            onChange={setCompanyName}
                        />
                        <InputAnimated type="password" label="Contraseña"
                            value={password}
                            onChange={setPassword}
                            hasError={password && passwordConfirm && (password !== passwordConfirm)} />
                        <InputAnimated type="password" label="Confirmar Contraseña"
                            value={passwordConfirm}
                            onChange={setPasswordConfirm}
                            hasError={password && passwordConfirm && (password !== passwordConfirm)} />
                        <div className="_actions">
                            <span></span>
                            <button type="submit" disabled={registering || !inputsValid()}>
                                {
                                    registering ? 'Creando cuenta' :
                                        'Crear cuenta'
                                }
                            </button>
                        </div>
                    </form>
                </div>
                <Link to="/login">
                    ¿Ya tienes cuenta? <b>Entra</b>
                </Link>
            </div>
        </div>
    )
}

export default Register;